// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile {
  width: 100%;
}

.profile__form {
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 40px;
}

.profile__form__left {
  width: calc((100% - 40px) - 400px);
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.profile__form__left > h1 {
  inline-size: 100%;
  color: #777f87;
  font-size: 24px;
  font-weight: 600;
  padding-bottom: 6px;
}
.profile__form__left > div {
  width: calc((100% - 16px) / 2);
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.profile__form__left > div > label {
  width: 100%;
  height: 55px;
  border-radius: 8px;
  border: 1px solid var(--Border, #dde1eb);
  background: var(--White, #fff);
  display: flex;
  align-items: center;
  padding: 0 16px;
}

.profile__form__left > div > label > input {
  flex: 1 1;
  height: 100%;
  color: var(--Placeholder, #0c6b60);
  font-size: 16px;
  font-weight: 500;
}

.profile__form__left > div > label > input::placeholder {
  color: var(--Placeholder, #b2bac6);
}

.profile__form__left > div > label > button {
  display: flex;
  font-size: 20px;
  border: none;
  background: none;
  cursor: pointer;
}

.profile__form__right {
  width: 400px;
  border-radius: 30px;
  border: 1px solid #eceef4;
  padding: 30px;
  display: flex;
  flex-direction: column;
  gap: 17px;
}

.profile__form__right > div {
  width: 100%;
  height: 65px;
  border-radius: 8px;
  background: #dde1eb;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
}

.profile__form__right > div > p {
  color: var(--Dark-Gray, #60656e);
  font-size: 16px;
  font-weight: 500;
}

.profile__form__right > div > input {
  width: 130px;
  height: 40px;
  border-radius: 8px;
  background: #fff;
  padding: 0 16px;
}

.profile__form__right > figure {
  width: 100%;
  aspect-ratio: 1/1;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  border: 1px solid #eceef4;
}

.profile__form__right > figure .selected {
  width: 100%;
  height: 100%;
  aspect-ratio: 1/1;
  object-fit: cover;
  border-radius: 8px;
}

.profile__form__right > label {
  width: 100%;
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border-radius: 8px;
  background: #0c6b60;
  color: var(--White, #fff);
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
}

.profile__form__right > button {
  width: 100%;
  height: 55px;
  border-radius: 8px;
  background: #0c6b60;
  color: var(--White, #fff);
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  border: none;
}

.profile__requisites {
  width: 100% !important;
  display: flex;
  flex-direction: row !important;
  flex-wrap: wrap;
  gap: 16px;
  padding-top: 34px;
}

.profile__requisites > h1 {
  color: #777f87;
  font-size: 24px;
  font-weight: 600;
}

.profile__requisites > .wf100 {
  width: 100%;
}

.profile__requisites > .wf50 {
  width: calc((100% - 16px) / 2);
}

@media (max-width: 1024px) {
  .profile__form__left {
    width: 100%;
  }
}

@media (max-width: 540px) {
  .profile__form__left > h1 {
    font-size: 18px;
  }

  .profile__form__right {
    width: 100%;
  }

  .profile__form__left > div {
    width: 100%;
  }

  .profile__form__left > div > label {
    height: 45px;
  }

  .profile__form__left > div > label > input {
    font-size: 14px;
  }

  .profile__requisites > h1 {
    font-size: 18px;
  }

  .profile__form__right {
    border-radius: 8px;
    padding: 19px;
  }

  .profile__form__right > div {
    height: 55px;
    padding: 0 15px;
  }

  .profile__form__right > div > p {
    font-size: 14px;
  }

  .profile__form__right > div > input {
    width: 120px;
    height: 38px;
    padding: 0 15px;
  }

  .profile__form__right > label {
    height: 50px;
    font-size: 14px;
  }

  .profile__form__right > button {
    height: 50px;
    font-size: 14px;
  }
}

@media (max-width: 380px) {
  .profile__requisites > .wf50 {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/profile/style.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,kCAAkC;EAClC,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF","sourcesContent":[".profile {\n  width: 100%;\n}\n\n.profile__form {\n  width: 100%;\n  display: flex;\n  align-items: flex-start;\n  flex-wrap: wrap;\n  gap: 40px;\n}\n\n.profile__form__left {\n  width: calc((100% - 40px) - 400px);\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.profile__form__left > h1 {\n  inline-size: 100%;\n  color: #777f87;\n  font-size: 24px;\n  font-weight: 600;\n  padding-bottom: 6px;\n}\n.profile__form__left > div {\n  width: calc((100% - 16px) / 2);\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.profile__form__left > div > label {\n  width: 100%;\n  height: 55px;\n  border-radius: 8px;\n  border: 1px solid var(--Border, #dde1eb);\n  background: var(--White, #fff);\n  display: flex;\n  align-items: center;\n  padding: 0 16px;\n}\n\n.profile__form__left > div > label > input {\n  flex: 1;\n  height: 100%;\n  color: var(--Placeholder, #0c6b60);\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.profile__form__left > div > label > input::placeholder {\n  color: var(--Placeholder, #b2bac6);\n}\n\n.profile__form__left > div > label > button {\n  display: flex;\n  font-size: 20px;\n  border: none;\n  background: none;\n  cursor: pointer;\n}\n\n.profile__form__right {\n  width: 400px;\n  border-radius: 30px;\n  border: 1px solid #eceef4;\n  padding: 30px;\n  display: flex;\n  flex-direction: column;\n  gap: 17px;\n}\n\n.profile__form__right > div {\n  width: 100%;\n  height: 65px;\n  border-radius: 8px;\n  background: #dde1eb;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 16px;\n}\n\n.profile__form__right > div > p {\n  color: var(--Dark-Gray, #60656e);\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.profile__form__right > div > input {\n  width: 130px;\n  height: 40px;\n  border-radius: 8px;\n  background: #fff;\n  padding: 0 16px;\n}\n\n.profile__form__right > figure {\n  width: 100%;\n  aspect-ratio: 1/1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  border: 1px solid #eceef4;\n}\n\n.profile__form__right > figure .selected {\n  width: 100%;\n  height: 100%;\n  aspect-ratio: 1/1;\n  object-fit: cover;\n  border-radius: 8px;\n}\n\n.profile__form__right > label {\n  width: 100%;\n  height: 55px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  border-radius: 8px;\n  background: #0c6b60;\n  color: var(--White, #fff);\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.profile__form__right > button {\n  width: 100%;\n  height: 55px;\n  border-radius: 8px;\n  background: #0c6b60;\n  color: var(--White, #fff);\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  border: none;\n}\n\n.profile__requisites {\n  width: 100% !important;\n  display: flex;\n  flex-direction: row !important;\n  flex-wrap: wrap;\n  gap: 16px;\n  padding-top: 34px;\n}\n\n.profile__requisites > h1 {\n  color: #777f87;\n  font-size: 24px;\n  font-weight: 600;\n}\n\n.profile__requisites > .wf100 {\n  width: 100%;\n}\n\n.profile__requisites > .wf50 {\n  width: calc((100% - 16px) / 2);\n}\n\n@media (max-width: 1024px) {\n  .profile__form__left {\n    width: 100%;\n  }\n}\n\n@media (max-width: 540px) {\n  .profile__form__left > h1 {\n    font-size: 18px;\n  }\n\n  .profile__form__right {\n    width: 100%;\n  }\n\n  .profile__form__left > div {\n    width: 100%;\n  }\n\n  .profile__form__left > div > label {\n    height: 45px;\n  }\n\n  .profile__form__left > div > label > input {\n    font-size: 14px;\n  }\n\n  .profile__requisites > h1 {\n    font-size: 18px;\n  }\n\n  .profile__form__right {\n    border-radius: 8px;\n    padding: 19px;\n  }\n\n  .profile__form__right > div {\n    height: 55px;\n    padding: 0 15px;\n  }\n\n  .profile__form__right > div > p {\n    font-size: 14px;\n  }\n\n  .profile__form__right > div > input {\n    width: 120px;\n    height: 38px;\n    padding: 0 15px;\n  }\n\n  .profile__form__right > label {\n    height: 50px;\n    font-size: 14px;\n  }\n\n  .profile__form__right > button {\n    height: 50px;\n    font-size: 14px;\n  }\n}\n\n@media (max-width: 380px) {\n  .profile__requisites > .wf50 {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
